/* global globalThis */
import { useEffect } from "react";
import { Box, Button, Typography, Container, Paper } from "@mui/material";

import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { persistor } from "../../redux/store";
import TimeOutIcon from "../../assets/timeOut.svg";
import NoRoleHeader from "../noRole/noRoleHeader";

const SessionExpired = () => {
  const dispatch = useDispatch();

  // Check if this is an idle timeout or max session expiration

  const errorMessage =
    "Your session has expired due to inactivity or exceeding the maximum session time limit.";

  useEffect(() => {
    // Wipe stored data as soon as the session is expired
    localStorage.clear();
    sessionStorage.clear();
    persistor.purge();

    // Block browser back navigation while on this page
    globalThis.history.pushState(null, "", globalThis.location.href);
    const blockBack = () => {
      globalThis.history.pushState(null, "", globalThis.location.href);
    };
    globalThis.addEventListener("popstate", blockBack);
    return () => globalThis.removeEventListener("popstate", blockBack);
  }, []);

  const handleLoginAgain = () => {
    // Clear all client-side storage to ensure filters and search values are cleared
    localStorage.clear();
    sessionStorage.clear();
    persistor.purge();
    // Clear existing auth state and reset store
    dispatch(logout());
    // Redirect to login page
    globalThis.location.href = "/landing";
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <NoRoleHeader hideProfileIcon />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Container
          component="main"
          maxWidth="sm"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            py: 4,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 450,
              textAlign: "center",
              height: "auto",
            }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 4,
                width: "100%",
                borderRadius: 2,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={TimeOutIcon}
                alt="Session Expired"
                sx={{
                  width: 80,
                  height: 80,
                  mb: 3,
                  color: "error.main",
                }}
              />
              <Typography
                component="h1"
                variant="h5"
                color="error"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  fontSize: "16px",
                  mb: 1,
                }}
              >
                401 - Session Expired
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  mb: 2,
                  fontSize: "16px",
                }}
              >
                {errorMessage}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleLoginAgain}
                sx={{
                  mt: 2,
                  px: 4,
                  py: 1.5,
                  borderRadius: "28px",
                  textTransform: "none",
                  fontSize: "1rem",
                  fontWeight: 500,
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  },
                  transition: "all 0.2s ease-in-out",
                }}
              >
                Login Again
              </Button>
            </Paper>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default SessionExpired;
